import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import { ConsultaSeguimentoPergunta14Model } from './model-consultaSeguimentoPergunta14'
import {
  hasPergunta14OlhaSeusOlhosAtLeastTwoSim,
  isPergunta14OlhaSeusOlhosAllFilled,
  isPergunta14OlhaSeusOlhosAllNao,
} from './utils-consultaSeguimentoPergunta14'

export const PERGUNTA_14_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta14Model> = {
  PERGUNTA_14_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_14_DEU_EXEMPLO_ABAIXO',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_14_OLHA_SEUS_OLHOS',
      },
    ],
  },
  PERGUNTA_14_DEU_EXEMPLO_ABAIXO: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_14_OLHA_SEUS_OLHOS',
      },
    ],
    dependsOn: 'PERGUNTA_14_HEADER',
  },
  PERGUNTA_14_OLHA_SEUS_OLHOS: {
    scrollConditions: [
      {
        if: (value) => hasPergunta14OlhaSeusOlhosAtLeastTwoSim(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => isPergunta14OlhaSeusOlhosAllFilled(value) && isPergunta14OlhaSeusOlhosAllNao(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => isPergunta14OlhaSeusOlhosAllFilled(value) && !isPergunta14OlhaSeusOlhosAllNao(value),
        scrollTo: 'PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_14_DEU_EXEMPLO_ABAIXO',
  },
  PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES',
      },
    ],
    dependsOn: 'PERGUNTA_14_OLHA_SEUS_OLHOS',
  },
  PERGUNTA_14_OLHA_SEUS_OLHOS_5_VEZES: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_14_OLHA_SEUS_OLHOS_TODOS_DIAS',
  },
}
